import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-61f8a621")

_pushScopeId("data-v-61f8a621")
const _hoisted_1 = { class: "tabContainer" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "d-flex mb_10" }
const _hoisted_4 = { class: "inputContainer tinyMceContainer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_tiny_mce_view = _resolveComponent("tiny-mce-view")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      (_ctx.titleKey)
        ? (_openBlock(), _createBlock(_component_localized_text, {
            key: 0,
            localizedKey: _ctx.titleKey,
            text: _ctx.titleValue,
            class: "input_title"
          }, null, 8, ["localizedKey", "text"]))
        : (_openBlock(), _createBlock("span", _hoisted_2)),
      _createVNode("div", _hoisted_3, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.locales, (langTab, i) => {
          return (_openBlock(), _createBlock("div", {
            class: ["tab", _ctx.selectedLocale == langTab ? 'active' : ''],
            key: i,
            onClick: ($event: any) => (_ctx.setInputLocale(langTab))
          }, _toDisplayString(langTab), 11, ["onClick"]))
        }), 128))
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_tiny_mce_view, {
        modelValue: _ctx.selectedInput,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedInput = $event))
      }, null, 8, ["modelValue"])
    ])
  ]))
})